<div class="wrapper mb-5">
    <div class="row align-items-center m-0" style="padding: 10px;">
        <img class="p-2" src="./assets/icons/arrow.svg">
        <span class="label-title ml-2 mr-3">Convite</span>
    </div>
    <div class="component-box container-fluid">
        <div class="row m-2">
            <div class="col-12 component-title pt-4">Convidar Novo {{gestorLabel}}</div>
            <form class="col-12" [formGroup]="gestorConviteFormGroup" #gestorConviteForm="ngForm"
                (ngSubmit)="onSubmit(gestorConviteFormGroup.value)">
                <div class="py-2 container-fluid">

                    <div class="row">
                        <div class="col-lg-6 col-md-6 col-sm-12 py-2 border-right">
                            <div class="custom-pr-5 mb-5">
                                <div class="custom-input-container">
                                    <input formControlName="nome" id="nome" class="custom-input-outline" type="text"
                                        #inName (blur)="InNameOnBlur(inName.value)" (focus)="InNameOnFocus()" />
                                    <label class="custom-label-outline label-required" for="nome">Nome: </label>
                                </div>
                                <div *ngIf="
                                        (form.nome.invalid &&
                                            (form.nome.dirty ||
                                                form.nome.touched)) ||
                                        InNameHasNumber
                                    " class="text-danger">
                                    <div *ngIf="form.nome?.errors?.required">
                                        Nome é obrigatório!
                                    </div>
                                    <div *ngIf="form.nome?.errors?.maxlength">
                                        Nome deve conter no máximo 100
                                        caracteres.
                                    </div>
                                    <div *ngIf="form.nome?.errors?.minlength">
                                        Nome deve conter no mínimo 3 caracteres.
                                    </div>
                                    <div *ngIf="InNameHasNumber">
                                        O nome do gestor não pode ter dígitos
                                        numéricos.
                                    </div>
                                </div>
                            </div>

                            <div class="custom-pr-5 mb-5">
                                <div class="custom-input-container">
                                    <input formControlName="email" id="email" class="custom-input-outline"
                                        type="email" />
                                    <label class="custom-label-outline label-required" for="email">E-mail: </label>
                                </div>
                                <div *ngIf="
                                        form.email.invalid &&
                                        (form.email.dirty || form.email.touched)
                                    " class="text-danger">
                                    <div *ngIf="form.email.errors.required">
                                        E-mail é obrigatório!
                                    </div>
                                    <div *ngIf="form.email.errors.email">
                                        Formato de e-mail inválido!
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="col-lg-6 col-md-6 col-sm-12 py-2">
                            <div class="custom-pr-5 mb-5">
                                <div class="custom-input-container">
                                    <input [textMask]="{
                                            mask: MASKS.cpf.textMask
                                        }" formControlName="cpf" id="cpf" class="custom-input-outline" type="text" />
                                    <label class="custom-label-outline label-required" for="cpf">CPF: </label>
                                </div>
                                <div *ngIf="
                                        form.cpf.invalid &&
                                        (form.cpf.dirty || form.cpf.touched)
                                    " class="text-danger">
                                    <div *ngIf="form.cpf.errors.required">
                                        CPF é obrigatório.
                                    </div>
                                    <div *ngIf="form.cpf.errors.cpf">
                                        CPF inválido.
                                    </div>
                                </div>
                            </div>

                            <div class="div-select-create custom-pr-5 py-2">
                                <div class="perfil-title label-required">Perfis:</div>
                                <div class="custom-input-container form-check-inline my-2"
                                    *ngFor="let listPerfis of perfisList">
                                    <input (change)="isChecked()" [attr.id]="
                                            'perfil-' + listPerfis.perfilId
                                        " class="checkbox mx-2" [(ngModel)]="listPerfis.selected"
                                        [ngModelOptions]="{ standalone: true }" type="checkbox" />
                                    <label [attr.for]="
                                            'perfil-' + listPerfis.perfilId
                                        " class="form-check-label">{{ listPerfis.nome }}</label>
                                </div>
                                <div *ngIf="perfilSelected === false">
                                    <span class="text-danger">Selecione ao menos um perfil.</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row button-container mt-5 mb-3">
                    <div class="col-12 text-right">
                        <button class="custom-button-full btn-back custom-button-previous" (click)="goToBack()">
                            Voltar
                        </button>

                        <button type="submit" class="custom-button-full">
                            Convidar
                        </button>
                    </div>
                </div>
            </form>
        </div>
    </div>
</div>

<!--Modal do Deletar -->
<ng-template #senhaGestorModal let-modal>
    <div class="col-12 modal-header clean-modal-header">
        <div class="col-md-12">
            <h5 class="clean-modal-title">Confimar Convite</h5>
        </div>
    </div>
    <div class="row col-12 clean-modal-content">
        <p class="col-12 clean-modal-subtitle" style="font-size: 20px;">
            Para confirmar o convite insira a sua senha:
        </p>
        <div class="col-12 custom-modal-title my-5 text-center">
            <div class="custom-filter-input-container">
                <label class="clean-filter-label" for="senhaGestor">Senha:</label>
                <input class="clean-filter-input w-50" id="senhaGestor" type="password" [(ngModel)]="senhaGestor" />
            </div>
        </div>
    </div>
    <div class="col-12 clean-modal-footer">
        <button class="custom-filter-button custom-filter-button-just" type="button" (click)="onSubmit(gestorConviteFormGroup.value); modal.dismiss('Close click')">
            Confirmar
        </button>
    </div>
</ng-template>

<!--Modal de Mensagem de Sucesso -->
<ng-template #modalSucesso let-modal>
    <div class="col-12 modal-header clean-modal-header">
        <div class="col-md-12">
            <h5 class="clean-modal-title">Convite enviado com sucesso</h5>
        </div>
    </div>
    <div class="row col-12 clean-modal-content">
        <p class="col-12 clean-modal-subtitle" style="font-size: 20px;">
            Aguarde até o novo gestor aceitar o convite
        </p>
    </div>
    <div class="col-12 clean-modal-footer">
        <button class="custom-filter-button custom-filter-button-just" type="button" (click)="modal.dismiss('Close click')">
            Fechar
        </button>
    </div>
</ng-template>

<!--Modal de Mensagem de Insucesso -->
<ng-template #modalInsucesso let-modal>
    <div class="col-12 modal-header clean-modal-header">
        <div class="col-md-12">
            <h5 class="clean-modal-title">Ops! Temos um problema</h5>
        </div>
    </div>
    <div class="row col-12 clean-modal-content">
        <p class="col-12 clean-modal-subtitle" style="font-size: 20px;">
            Não foi possível concluir a sua solicitação.<br>
            Tente novamente mais tarde.
        </p>
    </div>
    <div class="col-12 clean-modal-footer">
        <button class="custom-filter-button custom-filter-button-just" type="button" (click)="modal.dismiss('Close click')">
            Fechar
        </button>
    </div>
</ng-template>
